import { Component } from '@angular/core';

@Component({
  selector: 'app-bell-icon',
  templateUrl: './bell-icon.component.html',
  styleUrl: './bell-icon.component.scss',
})
export class BellIconComponent {}
